/* eslint-disable no-undef */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      loading: "Loading…",
      message_check_profile:
        "Incorrect User Information, Please contact Service Desk",
      greet: "Hello",
      logout_text: "Logout",
      text_notfound: "Data not found",
      more: "More",
      veiw_text: "Payroll cutoff Calendar",
      periodOff:
        "Advanced salary request will open to submit during 2nd- 5th of each month.",
      view: "view",
      notification: "Notification",
      notificationSuccess: "Your request has been submitted",
      notificationFail: "You have enter an invalid amount. Please try again",
      confirmCancel: "Do you want to cancel the request?",
      readmore: "Read more",
      message_data: "No Data",
      btn_confirm: "Yes",
      btn_cancel: "No",
      btn_ok: "Ok",
      btn_CloseWindow: "Close",
      accept: "Accept",
      decline: "Decline",
      cancel: "Cancel",
      submit: "Submit",
      back: "Back",
      toast_submitting: "Submitting...",
      toast_success: "Submitted successfully!",
      toast_error: "Something went wrong. Please try again!",
      consent: {
        user_agreement: {
          modal_title: "Data Privacy Consent Statement",
          first_tab_btn_label: "I have read and understood",
        },
      },
      CalendarPupup: "Calendar Payroll Cutoff",
      profile: {
        phone: "Phone",
        joined: "Joined",
        service_year: "Service Year",
      },
      adv_salary_request: {
        unit: "Bath",
        title: "Advance Salary Request",
        title_detail: "Request Details",
        massage: "Not over 50% of your Salary and Minimum 500",
        btn_send_request: "Send Request",
        btn_cancel: "Cancel",
        request: "Request",
        approved: "Approved",
        request_detail: "Request Amount",
        approved_detail: "Approved Amount",
        remark: "Remark",
      },
      timeanddate: {
        time_in_out: "Time In/Out",
        time_late_this_week: "Late",
        time_vacation_leave: "Vacation Leave Balance",
        time_sick_days: "Sick Leave",
      },
      time_list_box: {
        timeanddate_in_out: {
          title: "Time In Out",
          date: "Date",
          timein: "Time In",
          timeout: "Time Out",
          time_absence: "Absence",
          overtime: "OT",
          total: "Total",
          unit: "Hrs.",
        },
        timeanddate_late_this_week: {
          title: "Late Time",
          date: "Date",
          overtime: "Late Time",
          total: "Total",
          unit: "Hrs.",
        },
        timeanddate_vacation_leave: {
          title: "Vacation Leave",
          date: "Date",
          hour: "Hrs.",
          remark: "Remark",
          total: "Total",
          unit: "Days",
        },
        timeanddate_sick: {
          title: "Sick Leave",
          date: "Date",
          hour: "Hrs.",
          remark: "Remark",
          total: "Total",
          unit: "Hrs.",
        },
      },
      service_menu: {
        payroll_calendar: "Payroll Calendar",
        ppt_consent: "Privacy notice and consent",
        uniform_survey: "Uniform Survey",
        pttt: "Employee Purchase Program",
        srs: "Security Request",
        locker: "Locker Management",
      },
      uniform_survey: {
        allowBlock: "You are not eligible to submit uniform survey this year.",
        request_message: {
          request_title: "Warning!",
          request_gender_shirts: "Please select gender for shirts",
          request_gender_pants: "Please select gender for pants",
          request_shirts_message: "Please select the size for shirts.",
          request_pants_message: "Please select the size for pants.",
          request_dresses_message: "Please select the size for dresses.",
          request_slippers_message: "Please select the size for slippers.",
          request_bras_message: "Please select the size for a bra.",
          request_tumbler_message: "Please select the option for tumbler.",
          request_note_message: "Please input more detail",
          request_note_shirts: "Please input more detail shirts",
          request_note_pants: "Please input more detail pants",
          request_note_dress: "Please input more detail dresses",
          request_note_slippers: "Please input more detail slippers",
          request_note_bars: "Please input more detail bra",
        },
        error_message: {
          title: "Something went wrong",
          confirm_error: "Error on saving data. Please try again.",
          btn_again: "Try again",
          btn_no: "Close",
        },
        personal_information: {
          title: "Personal Information",
          employee_id: "Employee ID",
          employee_name: "Employee Name",
          gender: "Gender",
          phone_number: "Phone Number",
          department: "Department",
          job_title: "Job Title",
          email: "Email",
        },
        your_uniform: {
          infoUniform: {
            set1: "set 1",
            set3: "set 3",
            CloseModalPolicy: "CloseModalPolicy",
            AcceptModalPolicy: "Accept",
            IfNeeded: "If Needed",
          },
          periodOff:
            "Uniform survey closed for this year 2023 and will open to submit again in Q2 2024.",
          title: "Your Uniform",
          start_survey: "Start Survey",
          update_survey: "Update Survey",
          uniform_type: "Uniform Type",
          uniform_set: "Uniform Set",
          amount: "Amount",
          benefits: "Benefits",
          title_confirm_uniform: "Please confirm your current uniform.",
          title_change_uniform: "Please select your current uniform type.",
          select_uniform_type_title: "Uniform Type",
          select_uniform_job_level: "Job Level",
          btn_yes: "Yes",
          btn_cancel: "Cancel",
        },
        choose_uniform: {
          size: "Size",
          UnitSlipper: "cm",
          UnitBar: "inc",
          title: "Select Uniform Size",
          btn_sumbit_uniform: "Confirm  uniform",
          female: "Female",
          male: "Male",
          size_chart: "Size Chart",
          select_size: "--- Choose Size ---",
          select_tumbler: "--- Choose Receive  ---",
          no_receive: "Decline",
          receive: "Accept",
          big_size: "Bigger than normal size",
          messages_alert_big_size: `*If you selected “Bigger than normal size", HR would contact you for further information.`,
          choose_message: {
            title: "Something went wrong!",
          },
          remarkConfrim:
            'If you press "Confirm," you will not be able to change the quantity of uniform anymore.',
          remark: "Remark",
          remarkCaseRed:
            "The company will distribute white polo shirts with red collar until stock runs out before give away white-grey collar.",
        },
        conform_your_uniform_set: {
          title: "Please confirm your uniform set",
        },
        conform_your_uniform: {
          title: "Please confirm your uniform type",
          btn_confirm: "Confirm",
          btn_confirming: "Confirming...",
          btn_cancel: "Cancel",
          btn_yes: "yes",
          btn_no: "No",
          messages_alert_contect_admin: `*If you selected “Bigger than normal size", HR would contact you for further information.`,
        },
        latest_uniform_survey: {
          title: "Your Selection",
          date: "Date",
        },
        last_uniform_survey: {
          title: "Last Uniform Survey",
          date: "Date",
        },
        message_successfully: "You submitted uniform successfully.",
      },
      accept: "Accept",
      decline: "Decline",
      cancel: "Cancel",
      submit: "Submit",
      consent: {
        user_agreement: {
          modal_title: "Data Privacy Consent Statement",
          first_tab_btn_label: "I have read and understood",
        },
      },
    },
  },
  vi: {
    translation: {
      loading: "กำลังประมวลผล…",
      message_check_profile: "ข้อมูลผู้ใช้ไม่ถูกต้อง กรุณาติดต่อ Service Desk",
      greet: "สวัสดี",
      logout_text: "ออกจากระบบ",
      text_notfound: "ไม่พบข้อมูล",
      more: "อ่านต่อ",
      veiw_text: "ปฏิทินการเบิกเงินกลางเดือน",
      view: "แสดง",
      notification: "แจ้งเตือน",
      notificationSuccess: "เราได้รับข้อมูลของท่านเรียบร้อยแล้ว",
      notificationFail: "คุณระบุยอดเงินไม่ถูกต้อง กรุณาระบุยอดเงินใหม่อีกครั้ง",
      confirmCancel: "คุณต้องการยกเลิกการขอ หรือไม่?",
      periodOff: "เบิกเงินกลางเดือนจะเปิดตั้งแต่วันที่ 2-5 ของทุก ๆ เดือน",
      readmore: "อ่านต่อ",
      message_data: "ไม่พบข้อมูล",
      btn_confirm: "ใช่",
      btn_cancel: "ไม่ใช่",
      btn_ok: "ตกลง",
      btn_CloseWindow: "ปิด",
      accept: "Chấp nhận",
      decline: "Từ chối",
      cancel: "Hủy",
      submit: "Gửi",
      back: "Quay lại",
      toast_submitting: "Đang gửi dữ liệu...",
      toast_success: "Gửi dữ liệu thành công!",
      toast_error: "Đã xảy ra lỗi. Vui lòng thử lại!",
      consent: {
        user_agreement: {
          modal_title: "Data Privacy Consent Statement",
          first_tab_btn_label: "Tôi đã đọc và hiểu nội dung nêu trên",
        },
      },
      CalendarPupup: "ปฏิทินการจ่ายเงินเดือน",
      profile: {
        phone: "เบอร์โทร",
        joined: "วันเร่ิมงาน",
        service_year: "อายุงาน",
      },
      adv_salary_request: {
        unit: "บาท",
        title: "ขอเบิกเงินกลางเดือน",
        title_detail: "รายละเอียดการขอเบิกเงินล่าสุด",
        massage: "สามารถเบิกได้ไม่เกิน 50% ของเงินเดือนและขั้นต่ำ 500 บาท",
        btn_send_request: "ส่งคำร้องขอ",
        btn_cancel: "ยกเลิกคำร้องขอ",
        request: "ขอเบิกเงิน",
        approved: "เบิกได้จริง",
        request_detail: "จำนวนเงินที่ต้องการเบิกล่วงหน้า",
        approved_detail: "จำนวนเงินที่ได้รับอนุมัติแล้ว",
        remark: "หมายเหตุ",
      },
      timeanddate: {
        time_in_out: "เวลา เข้า/ออก",
        time_late_this_week: "เวลาที่สาย",
        time_vacation_leave: "ลาพักร้อนคงเหลือ",
        time_sick_days: "ลาป่วย",
      },
      time_list_box: {
        timeanddate_in_out: {
          title: "เวลา เข้า/ออก",
          date: "วันที่",
          timein: "เวลาเข้า",
          timeout: "เวลาออก",
          time_absence: "ขาดงาน",
          overtime: "ล่วงเวลา",
          total: "รวม",
          unit: "ชม.",
        },
        timeanddate_late_this_week: {
          title: "สาย",
          date: "วันที่",
          overtime: "จำนวนชั่วโมง",
          total: "รวม",
          unit: "ชม.",
        },
        timeanddate_vacation_leave: {
          title: "ประวัติลาพักร้อน",
          date: "วันที่",
          hour: "ชม.",
          remark: "เหตุผล",
          total: "รวม",
          unit: "วัน",
        },
        timeanddate_sick: {
          title: "ลาป่วย",
          hour: "ชั่วโมง",
          date: "วันที่",
          remark: "เหตุผล",
          total: "รวม",
          unit: "ชม.",
        },
      },
      service_menu: {
        payroll_calendar: "ปฏิทินเบิกเงิน",
        ppt_consent: "นโยบายความเป็นส่วนตัวและการให้ความยินยอม",
        uniform_survey: "แบบสำรวจเครื่องแบบ",
        pttt: "สินค้าสำหรับกลุ่มลูกค้าพนักงาน",
        srs: "บริการด้านการรักษาความปลอดภัย",
        locker: "จัดการล็อกเกอร์ของฉัน",
      },
      uniform_survey: {
        allowBlock: "คุณไม่มีสิทธิ์ในการกรอก survey  ในรอบปีนี้",
        request_message: {
          request_title: "แจ้งเตือน",
          request_gender_shirts: "กรุณาเลือกเพศของเสื้อ",
          request_gender_pants: "กรุณาเลือกเพศของกางเกง",
          request_shirts_message: "กรุณาเลือกขนาดไซส์เสื้อ",
          request_pants_message: "กรุณาเลือกขนาดไซส์กางเกง",
          request_dresses_message: "กรุณาเลือกขนาดไซส์ชุดกระโปรง",
          request_slippers_message: "กรุณาเลือกขนาดไซส์รองเท้าเตะ",
          request_bras_message: "กรุณาเลือกขนาดไซส์เสื้อชั้นใน",
          request_tumbler_message: "กรุณาเลือกจะรับแก้วน้ำหรือไม่",
          request_note_message: "ป้อนรายละเอียดเพิ่มเติม",
          request_note_shirts: "ป้อนรายละเอียดเพิ่มเติมเสื้อ",
          request_note_pants: "ป้อนรายละเอียดเพิ่มเติมกางเกง",
          request_note_dress: "ป้อนรายละเอียดเพิ่มเติมชุดประโปรง",
          request_note_slippers: "ป้อนรายละเอียดเพิ่มเติมรองเท้าเตะ",
          request_note_bars: "ป้อนรายละเอียดเพิ่มเติมชุดชั้นใน",
        },
        error_message: {
          title: "เกิดข้อผิดพลาด",
          confirm_error: "เกิดข้อผิดพลาดบางอย่าง กรุณาลองใหม่อีกครั้ง",
          btn_again: "ลองอีกครั้ง",
          btn_no: "ปิด",
        },
        personal_information: {
          title: "ข้อมูลส่วนตัว",
          employee_id: "รหัสพนักงาน",
          employee_name: "ชื่อ-สกุล",
          gender: "เพศ",
          phone_number: "เบอร์โทร",
          department: "แผนก",
          job_title: "ตำแหน่ง",
          email: "อีเมลล์",
        },
        your_uniform: {
          infoUniform: {
            set1: "เช็ตที่ 1",
            set3: "เช็ตที่ 3",
            CloseModalPolicy: "ไม่ยอมรับ",
            AcceptModalPolicy: "ยอมรับ",
            IfNeeded: "ถ้าต้องการ",
          },
          periodOff:
            "การสำรวจเครื่องแบบสำหรับปี 2566 ได้ปิดตัวลงแล้ว พบกันใหม่กลางปีหน้าค่ะ",
          title: "เครื่องแบบปัจจุบัน",
          start_survey: "เริ่มทำแบบสำรวจ",
          update_survey: "แก้ไขแบบสำรวจ",
          uniform_type: "ประเภทเครื่องแบบ",
          uniform_set: "เซ็ตเครื่องแบบ",
          amount: "จำนวน",
          benefits: "สิทธิ์ที่ได้รับ",
          title_confirm_uniform: "โปรดยืนยันเครื่องแบบปัจจุบัน",
          title_change_uniform: "โปรดระบุเครื่องแบบของคุณ",
          select_uniform_type_title: "ประเภทเครื่องแบบ",
          select_uniform_job_level: "ระดับพนักงาน",
          btn_yes: "ยืนยัน",
          btn_cancel: "ยกเลิก",
        },
        choose_uniform: {
          size: "ขนาด",
          UnitSlipper: "ซม.",
          UnitBar: "นิ้ว",
          title: "เลือกขนาดเครื่องแบบ",
          btn_sumbit_uniform: "ยืนยันเครื่องแบบ",
          female: "ผู้หญิง",
          male: "ผู้ชาย",
          size_chart: "ตารางขนาด",
          select_size: "--- เลือกขนาด ---",
          select_tumbler: "--- เลือกความประสงค์  ---",
          no_receive: "ไม่ประสงค์รับ",
          receive: "ประสงค์รับ",
          big_size: "ขนาดใหญ่พิเศษ",
          messages_alert_big_size: `*กรณีสวมใส่ขนาดใหญ่กว่าไซส์ปกติ ให้เลือก “ขนาดใหญ่พิเศษ“ HR จะติดต่อกลับหาท่านในภายหลัง`,
          choose_message: {
            title: "เกิดข้อผิดพลาด",
          },
          remarkConfrim:
            'ถ้ากด "ยืนยัน" จะไม่สามารถเปลี่ยนแปลงจำนวนเครื่องแบบได้อีก ',
          remark: "หมายเหตุ",
          remarkCaseRed:
            "บริษัทจะทำการจัดแจกเสื้อสีขาว คอปกสีแดง ที่คงเหลือในสต๊อกให้หมดก่อนแจกเสื้อสีขาว คอปกสีเทา",
        },
        conform_your_uniform_set: {
          title: "โปรดยืนยันชุดจำนวนเครื่องแบบ",
        },
        conform_your_uniform: {
          title: "โปรดยืนยันประเภทเครื่องแบบ",
          btn_confirm: "ยืนยัน",
          btn_confirming: "กำลังยืนยัน...",
          btn_cancel: "ยกเลิก",
          btn_yes: "ใช่",
          btn_no: "ไม่ใช่",
          messages_alert_contect_admin:
            "*กรณีสวมใส่ขนาดใหญ่กว่าไซส์ปกติ ให้เลือก “ขนาดใหญ่พิเศษ“ HR จะติดต่อกลับหาท่านในภายหลัง ",
        },
        latest_uniform_survey: {
          title: "ข้อมูลล่าสุดของท่าน",
          date: "วันที่",
        },
        last_uniform_survey: {
          title: "แบบสำรวจเครื่องแบบล่าสุด",
          date: "วันที่",
        },
        message_successfully: "คุณได้ทำแบบสำรวจเสร็จเรียบร้อยแล้ว",
      },
      accept: "Chấp nhận",
      decline: "Từ chối",
      cancel: "Hủy",
      submit: "Gửi",
      consent: {
        user_agreement: {
          modal_title: "Tuyên bố đồng ý về bảo mật dữ liệu",
          first_tab_btn_label:
            "Tôi đã đọc và hiểu đầy đủ nội dung tuyên bố trên.",
        },
      },
    },
  },
};

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("Language")
      ? localStorage.getItem("Language")
      : "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
